// src/views/Settings/UserSettings.jsx
//
// El alcance del usuario: lo que te sigue cambies de organización o no.
// Se llega desde el menú del avatar, que es el gesto correcto — el avatar eres
// tú, así que lo que cuelga de él es tuyo. Lo de la organización y lo de la
// cuenta se alcanzan desde donde vive cada uno, no desde aquí.
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProfileSection from './user/ProfileSection';
import SecuritySection from './user/SecuritySection';
import PreferencesSection from './user/PreferencesSection';
import {
  SCOPES,
  isSettingsSection,
  defaultSectionFor,
  settingsPath,
} from '../../lib/settingsNav';

export default function UserSettings() {
  const { section } = useParams();
  const navigate = useNavigate();

  const active = isSettingsSection(SCOPES.USER, section) ? section : null;

  // Sección inválida en la URL -> a la primera, reemplazando la entrada del
  // historial para que el botón de atrás no rebote entre la URL mala y la buena.
  useEffect(() => {
    if (!active) {
      navigate(settingsPath(SCOPES.USER, defaultSectionFor(SCOPES.USER)), { replace: true });
    }
  }, [active, navigate]);

  if (!active) return null;

  // El shell lo monta `SettingsLayout`, en la ruta padre: aquí solo va el
  // contenido de la sección.
  return (
    <>
      {active === 'profile' && <ProfileSection />}
      {active === 'security' && <SecuritySection />}
      {active === 'preferences' && <PreferencesSection />}
    </>
  );
}
